import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import type { CellProps } from 'react-table';
import { cx, getLocationFor, slugify } from '@trinity/chat-components';
import { ProjectPopoverAnchor } from '@/components/GroupProject';
import type { DashboardsTableItem, QuantAnalysesTableItem, TranscriptsTableItem } from './interfaces';
import styles from './style/Cell.Name.module.css';

export default function Name({ row: { original: data } }: CellProps<TranscriptsTableItem | DashboardsTableItem | QuantAnalysesTableItem>) {
  const to = useMemo(() => {
    if (!data.metadata.project) return null;
    const slug = slugify({ id: data.metadata.project.id, name: data.metadata.project.name });
    return getLocationFor.project.root({ slug });
  }, [data.metadata.project]);

  if (!data.metadata.project) return null;

  return (
    <div className={styles.root}>
      <div className={styles.details}>
        <ProjectPopoverAnchor item={data.metadata.project}>
          <Link to={to}>
            <div className={cx(styles.name, styles.unbolded)}>{data.metadata.project.name}</div>
          </Link>
        </ProjectPopoverAnchor>
      </div>
    </div>
  );
}

export { Name };